import axios from '@axios'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useNewTaskModal() {
  // Use toast
  const toast = useToast()

  const fetchGroups = queryParam => axios
    .get('/auth/groups-for-select', {
      params: queryParam,
    })
    .then(response => response.data.data)
    .catch(() => toast({
      component: ToastificationContent,
      props: {
        title: 'Error fetching groups',
        icon: 'AlertTriangleIcon',
        variant: 'danger',
      },
    }))

  const fetchForms = queryParam => axios
    .get('/auth/forms', {
      params: queryParam,
    })
    .then(response => response.data.data)
    .catch(() => toast({
      component: ToastificationContent,
      props: {
        title: 'Error fetching groups',
        icon: 'AlertTriangleIcon',
        variant: 'danger',
      },
    }))

  const fetchTask = id => axios
    .get(`/auth/tasks/${id}`)
    .then(response => response.data.data)
    .catch(() => toast({
      component: ToastificationContent,
      props: {
        title: 'Error fetching the task',
        icon: 'AlertTriangleIcon',
        variant: 'danger',
      },
    }))

  const createTask = queryParams => axios
    .post('/auth/tasks', queryParams)
    .then(response => {
      toast({
        component: ToastificationContent,
        props: {
          title: 'Task was successfully created',
          icon: 'ThumbsUpIcon',
          variant: 'info',
        },
      })
      return response.data.data
    })
    .catch(() => toast({
      component: ToastificationContent,
      props: {
        title: 'Error creating new task',
        icon: 'AlertTriangleIcon',
        variant: 'danger',
      },
    }))

  const updateTask = queryParams => axios
    .put(`/auth/tasks/${queryParams.id}`, queryParams)
    .then(response => {
      toast({
        component: ToastificationContent,
        props: {
          title: 'Task was successfully updated',
          icon: 'ThumbsUpIcon',
          variant: 'info',
        },
      })
      return response.data.data
    })
    .catch(() => toast({
      component: ToastificationContent,
      props: {
        title: 'Error updating the task',
        icon: 'AlertTriangleIcon',
        variant: 'danger',
      },
    }))

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  return {
    fetchGroups,
    fetchForms,
    fetchTask,
    createTask,
    updateTask,
  }
}
